import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import WhyChoose from './components/WhyChoose';
import Requirements from './components/Requirements';
import CTA from './components/CTA';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <WhyChoose />
      <Requirements />
      <CTA />
      <Footer />
    </div>
  );
}

export default App;